<template>
    <div class="car-quote-step discounts">
        <quote-step-header
            :key="currentSubStep"
            :totalSteps="step.totalSteps"
            :currentStep="currentSubStep + 1"
            :title="subStepFields.title"
            :subtitle="subStepFields.subtitle"
        ></quote-step-header>

        <form class="quote-form" @submit.prevent="next">
            <div class="form-group">
                <div class="form-row flex center start large-gap">
                    <div class="row-item">
                        <!-- <div class="row-item-title">
                            {{ trans("has_extra_car") }}
                        </div> -->
                        <!-- <div class="form-group">
                            <app-text-radio-buttons
                                v-model="form[stepName].hasExtraCar"
                                :message="errors.get('hasExtraCar')"
                                :items="yesNoItems"
                                fixed-mobile
                            >
                            </app-text-radio-buttons>
                        </div> -->
                        <!-- <div class="row-item-title">
                            {{ trans("shabbatDriving") }}
                        </div>
                        <div class="form-group">
                            <app-text-radio-buttons
                                v-model="form[stepName].shabbatDriving"
                                :message="errors.get('shabbatDriving')"
                                :items="yesNoItems"
                                fixed-mobile
                            >
                            </app-text-radio-buttons>
                        </div> -->

                        <div class="row-item-title">
                            {{ trans("estimatedYearlyKm") }}
                        </div>
                        <div class="form-group">
                            <app-select
                                :items="constants.YEARLY_KM_ITEMS"
                                :message="errors.get('oneYear.insuranceType')"
                                v-model="form[stepName].estimatedYearlyKm"
                                rounded
                            ></app-select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    <template v-if="currentSubStep < subSteps.length - 1">
                        {{ "quote.welcome.next" | __ }}
                    </template>
                    <template v-else>
                        {{ "quote.car.get_quotes" | __ }}
                    </template>
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";

export default {
    name: "CarQuoteDiscounts",

    mixins: [QuoteStep],

    props: {},

    data() {
        return {
            subSteps: ["discounts"]
        };
    },

    mounted() {
        // Code executed after the component is mounted
        console.log(
            "mounted DISCOUNTS insuranceType >>>>",
            this.form.CarQuotePassedInsurance.oneYear.insuranceType
        );
    },

    computed: {
        canMoveNext() {
            switch (this.subStep) {
                case "discounts": {
                    return (
                        // this.stepFormFields.hasExtraCar != null &&
                        // this.stepFormFields.shabbatDriving != null &&
                        this.stepFormFields.estimatedYearlyKm !== false
                    );
                }
            }

            return true;
        },
        yesNoItems() {
            return [
                {
                    label: this.$trans("quote.car.yes"),
                    value: true
                },
                {
                    label: this.$trans("quote.car.no"),
                    value: false
                }
            ];
        }
    }
};
</script>

<style lang="scss"></style>
